var Config = {
  DELETION_URL: 'https://auth-4ds.olx.com.br/bff/anuncio',
  MYADS_POS_URL: 'https://apigw.olx.com.br/mydata',
  AUTHORIZATION_TAG: 'tag:scmcoord.com,2013:api',
  MOBILE_MAX_WIDTH: 640,
  MYADS_RELOAD_HOSTS: ['www3.olx.com.br', 'conta.olx.com.br', 'm2.olx.com.br'],
  MYADS_DESKTOP_REDIRECT: 'https://www3.olx.com.br/account/userads',
  MYADS_MOBILE_REDIRECT: 'https://m2.olx.com.br/contas/meus_anuncios'
};
export default Config;